import { render, staticRenderFns } from "./quote-details.vue?vue&type=template&id=6457c4f6&"
import script from "./quote-details.vue?vue&type=script&lang=js&"
export * from "./quote-details.vue?vue&type=script&lang=js&"
import style0 from "./quote-details.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports